document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll(".image-text-slider .slideshow-image");

  if (images.length === 0) {
    console.warn("No images found for the slider. Skipping script execution.");
    return; 
  }

  let currentIndex = 0;
  images[currentIndex].classList.add("active");

  function showNextImage() {
    images[currentIndex].classList.remove("active");

    currentIndex = (currentIndex + 1) % images.length;

    images[currentIndex].classList.add("active");
  }

  setInterval(showNextImage, 3000);
});



/* slider */
    $(".slider").slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 500,
      autoplaySpeed: 5000,
      autoplay: true,
      centerMode: true,
      centerPadding: "0",
      arrows: true,
      prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0426/7835/4069/files/long-arrow-left.png?v=1735124516" alt="Previous">Previous</button>',
      nextArrow: '<button class="slick-next">Next<img src="https://cdn.shopify.com/s/files/1/0426/7835/4069/files/long-arrow-right.png?v=1735124516" alt="Next"></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            centerMode: true, // Enable center mode for mobile
            centerPadding: "20px", // Add padding for better visibility
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true, // Enable center mode for smaller screens
            centerPadding: "20px", // Add padding for better visibility
          },
        },
      ],
    });